export default function loadPageFragment({
  url,
  targetFragmentId,
  scrollToTop=true,
  moveFocus=true,
  successCallback=()=>{},
  fallbackUrl=url,
  addFragmentPrefixToUrl=true}) {
  // Construct a link with the original url so we can get the path/query string from it
  // dummyLink.pathname will include the contextPath, so remove it and re-prefix the url
  let contextPath = ETL_PS_CONFIG.contextPath;
  const dummyLink = $(`<a href="${url}"></a>`)[0];
  const pathnameStartsWithContextPath = dummyLink.pathname.indexOf(contextPath) === 0;
  const fragmentUrl = `${contextPath}${(addFragmentPrefixToUrl) ? '/fragment' : ''}${dummyLink.pathname.substr((pathnameStartsWithContextPath) ? contextPath.length : 0)}${dummyLink.search}`;

  if (scrollToTop) {
    window.scrollTo(0,0);
  }

  fadeFragment(targetFragmentId);

  $.ajax(fragmentUrl)
    .then(
      function success(fragment) {
        $(`*[data-fragment-id="${targetFragmentId}"]`).replaceWith($(fragment));

        if (moveFocus) {
          $(`*[data-focus-target-for-fragment-id="${targetFragmentId}"]`).focus();
        }

        successCallback();
      },

      function fail() {
        // If the XHR request fails, go to the URL that would have been used if the page wasn't progressively enhanced
        window.location = fallbackUrl;
      }
    );
}

export function fadeFragment(fragmentId) {
  $(`*[data-fragment-id="${fragmentId}"]`).addClass('etl-ps-fragment-loading');
}
